/**
 * Client-side ticketing UI sync only (data lives in the API / database).
 */

export const TICKETING_DATA_CHANGED_EVENT = 'ticketing-data-changed';

/** Default form template when legacy rows lack formKey (should not happen for DB-backed categories). */
export const DEFAULT_TICKETING_FORM_KEY = 'hr_employee_it';

export function dispatchTicketingDataChanged() {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(TICKETING_DATA_CHANGED_EVENT));
}
